import { WifiOff } from 'lucide-react';
import { usePWA } from '../hooks/usePWA';

export function OfflineIndicator() {
  const { isOnline } = usePWA();

  if (isOnline) return null;

  return (
    <div className="fixed top-4 left-4 right-4 z-50 bg-red-600 text-white rounded-lg shadow-lg p-3 max-w-sm mx-auto">
      <div className="flex items-center gap-2">
        <WifiOff className="w-4 h-4" />
        <span className="text-sm font-medium">
          Você está offline
        </span>
      </div>
      <p className="text-xs opacity-90 mt-1">
        Algumas funcionalidades podem não estar disponíveis
      </p>
    </div>
  );
} 